<div class="grid grid-cols-12">
  <div class="col-span-12">
    <div class="mt-8 flex justify-center">
      <mat-button-toggle-group
        [value]="activeRoute"
        (change)="onToggleChange($event)"
      >
        <mat-button-toggle value="users" class="w-[120px]">
          Users
        </mat-button-toggle>

        <mat-button-toggle value="pages" class="w-[120px]">
          Pages
        </mat-button-toggle>

        <mat-button-toggle value="platforms" class="w-[120px]">
          Platforms
        </mat-button-toggle>

        <mat-button-toggle value="feeds" class="w-[120px]">
          Feeds
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
</div>